import script from "./KeyboardArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyboardArea.vue?vue&type=script&setup=true&lang=ts"

import "./KeyboardArea.vue?vue&type=style&index=0&id=49c4aaa2&lang=css"
import "./KeyboardArea.vue?vue&type=style&index=1&id=49c4aaa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c4aaa2"]])

export default __exports__